const envConfig = require("./env");

const isDevelopment =
  process.env.NODE_ENV === "development" ||
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const backendUrl = isDevelopment
  ? envConfig.development.backend
  : envConfig.production.backend;

const config = {
  api: {
    baseURL: backendUrl,
    apiPath: "/api",
    timeout: 30000,
  },
} as const;

export default config;

